import { useQuery } from '@tanstack/react-query';
import { checkFactorOnlineAvailability } from '../../functions/checkFactorOnlineAvailability';

export function useFactorOnlineAvailability(slug: string, serviceId: string) {
  // Isolated from legacy centers queries, whose fetcher converts failures into [].
  const query = useQuery(['factorOnlineAvailability', slug, serviceId], () => checkFactorOnlineAvailability(slug, serviceId), {
    enabled: !!slug && !!serviceId,
    staleTime: 0,
    keepPreviousData: false,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    retry: 1,
  });
  const state = query.isFetching || query.isLoading ? 'checking' : query.isError ? 'error' : query.data?.status ?? 'checking';
  return { ...query, state };
}
